"use strict";
var reflector_1 = require("./reflector");
var reflection_capabilities_1 = require("./reflection_capabilities");
/**
 * The {@link Reflector} used internally in Angular to access metadata
 * about symbols.
 */
exports.reflector = new reflector_1.Reflector(new reflection_capabilities_1.ReflectionCapabilities());
//# sourceMappingURL=reflection.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-metadata/src/core/reflection/reflection.js
// module id = 107
// module chunks = 6